import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { SkipByAuthInterceptorContext } from '../contexts/skip-by-auth-interceptor-context';
import { SkipByRefreshTokenInterceptorContext } from '../contexts/skip-by-refresh-token-interceptor-context';
import { SkipByLoadingInterceptorContext } from '../contexts/skip-by-loading-interceptor-context';
import { SkipByHttpErrorInterceptorContext } from '../contexts/skip-by-http-error-interceptor-context';
import { CacheInterceptorContext } from '../contexts/cache-interceptor-context';

@Injectable({
  providedIn: 'root',
})
export class HttpContextBuilder {
  private context = new HttpContext();

  public constructor() {
    this.reset();
  }

  public reset(): this {
    this.context = new HttpContext();

    return this;
  }

  public skipByAuthTokenInterceptor(): this {
    this.context.set(SkipByAuthInterceptorContext, true);

    return this;
  }

  public skipByRefreshTokenInterceptor(): this {
    this.context.set(SkipByRefreshTokenInterceptorContext, true);

    return this;
  }

  public withOptionalSkipByLoadingInterceptor(condition: () => boolean): this {
    if (condition()) {
      this.skipByLoadingInterceptor();
    }

    return this;
  }

  public skipByLoadingInterceptor(): this {
    this.context.set(SkipByLoadingInterceptorContext, true);

    return this;
  }

  public skipByHttpErrorInterceptor(): this {
    this.context.set(SkipByHttpErrorInterceptorContext, true);

    return this;
  }

  public withOptionalCacheInterceptor(condition: () => boolean): this {
    if (condition()) {
      return this.withCacheInterceptor();
    }

    return this;
  }

  public withCacheInterceptor(): this {
    this.context.set(CacheInterceptorContext, true);

    return this;
  }

  public build(): HttpContext {
    const context = this.context;

    this.reset();

    return context;
  }
}
